import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/degree";
const path_degree: string = "degree";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class degreeApi extends BaseAPI {
  static getAllDegree(query: listType): Promise<AxiosResponse> {
    return this.api.get(`student/${path_degree}`, {
      params: { ...query },
    });
  }
  static tree(query: { search?: string }): Promise<AxiosResponse> {
    return this.api.get(`${path}/tree`, {
      params: { ...query },
    });
  }
  static getDegree(): Promise<AxiosResponse> {
    return this.api.get(`${path}`);
  }

  static postDegree(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static patchDegree(id: any, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static deleteDegree(id: any): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }




}
